import * as tslib_1 from "tslib";
import { TRANSACTIONS_CONFIG } from "../../config/api";
import { SettingsLoaderService } from "../settingsLoader.service";
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../loader.service";
var TransactionsService = /** @class */ (function (_super) {
    tslib_1.__extends(TransactionsService, _super);
    function TransactionsService(http, loaderService) {
        var _this = _super.call(this, loaderService) || this;
        _this.http = http;
        _this.loaderService = loaderService;
        _this.config = TRANSACTIONS_CONFIG;
        return _this;
    }
    TransactionsService.prototype.confirmation = function (paymentIntent) {
        // return timer(2500).pipe();
        return this.http.post(this.config.confirmation, { paymentIntent: paymentIntent });
    };
    TransactionsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function TransactionsService_Factory() { return new TransactionsService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.LoaderService)); }, token: TransactionsService, providedIn: "root" });
    return TransactionsService;
}(SettingsLoaderService));
export { TransactionsService };
